<rt-interview-base-box
  [question]="questionForm().value"
  [rtProtectedControl]="questionForm().get('attachmentIds')"
  [rtProtectedControlEnabled]="hasProtectedControls()"
  [invalid]="
    questionForm().invalid &&
    (questionForm().dirty || questionForm().touched) &&
    formSubmissionAttempt()
  "
>
  @if (files && files.length) {
    <div layout margin-bottom>
      <rt-attachments-list
        [attachments]="files"
        [small]="true"
        [deletable]="true"
        [canManageCandidates]="canManageCandidates()"
        (deleteClick)="dispatchDeleteFile($event)"
      />
    </div>
  }
  <rt-group variant="inline">
    <rt-button variant="tertiary" #fileSelectButton [loading]="!!uploading" class="flow-browse">
      {{ 'app.interview.file.label' | translate }}
    </rt-button>
  </rt-group>
</rt-interview-base-box>
